import React from 'react'
import Header from './Header'
import Footer from './Footer'
import SocialIcons from './SocialIcons'

export default function Treasury() {
    return (
        <>
            <div className="container pt-lg-5 pt-2">
                <h1 className="h1 text-center">Treasury</h1>
                <p className="text-center heading-desc col-lg-5 col-11 mx-auto">The value of the YRP Token will be maintained by the interest of the treasury</p>
                <div className="row mx-0">
                    <div className="col-lg-8 col-12 pl-lg-2 p-2">
                        <div className="box-1 p-lg-5 p-4">
                            <span className="text-faded pb-2">TOTAL VALUE LOCK IN TREASURY</span>
                            <h2 className="mb-0">$12,000,000,000</h2>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12 pl-lg-2 p-2">
                        <div className="box-1 box-gradient p-lg-5 p-4">
                            <span className=" pb-2">TOTAL EARN FROM START</span>
                            <h2 className="mb-0">$12 Billion </h2>
                        </div>
                    </div>
                </div>
                <div className="row mx-0">
                    <div className="col p-2" >
                        <div className="box-1 px-lg-4 px-4" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2 text-faded text-small fw-600">Total earn in last 24HR</small>
                            <p className="mb-0 text-pink">$ 12,000,000,000</p>
                        </div>
                    </div>

                    <div className="col p-2" >
                        <div className="box-1 px-lg-4 px-4" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2 text-faded text-small fw-600">Total earn in last 7 days</small>
                            <p className="mb-0 text-purple">$ 12,000,000,000</p>
                        </div>
                    </div>
                    <div className="col p-2" >
                        <div className="box-1 px-lg-4 px-4" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2 text-faded text-small fw-600">Total earn in last 30 days</small>
                            <p className="mb-0 text-pink">$ 12,000,000,000</p>
                        </div>
                    </div>
                    <div className="col p-2" >
                        <div className="box-1 px-lg-4 px-4" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2 text-faded text-small fw-600">Total earn in last 365 days</small>
                            <p className="mb-0 text-purple">$ 12,000,000,000</p>
                        </div>
                    </div>
                    <div className="col p-2" >
                        <div className="box-1 px-lg-4 px-4" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2 text-faded text-small fw-600">Total Burning Fund</small>
                            <p className="mb-0 text-pink">$ 12,000,000,000</p>
                        </div>
                    </div>

                </div>
                <div className="row mx-0">
                    <div className="col-lg-3 col-md-3 col p-2" >
                        <div className="box-1 box-1-color px-lg-4 px-3 py-lg-4 py-3" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2  text-small fw-600">Partnerships Value</small>
                            <div className="  fw-600 d-flex pt-2 fs-lg-7"> <div className="  fw-600 pe-lg-4 pe-1">$</div>  10,00000,0000</div>
                            <div className="  fw-600 d-flex pt-1 fs-lg-7"> <div className="  fw-600 pe-lg-4 pe-1">%</div>  30</div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col p-2" >
                        <div className="box-1 box-1-color px-lg-4 px-3 py-lg-4 py-3" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2  text-small fw-600">USD Value</small>
                            <div className=" fw-600 d-flex pt-2 fs-lg-7"> <div className=" fw-600 pe-lg-4 pe-1">$</div>  10,000,000</div>
                            <div className=" fw-600 d-flex pt-1 fs-lg-7"> <div className=" fw-600 pe-lg-4 pe-1">%</div>  50</div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col p-2" >
                        <div className="box-1 box-1-color px-lg-4 px-3 py-lg-4 py-3" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2  text-small fw-600">ETH Value</small>
                            <div className="  fw-600 d-flex pt-2 fs-lg-7"> <div className="  fw-600 pe-lg-4 pe-1">$</div>  10,0000,0000</div>
                            <div className="  fw-600 d-flex pt-1 fs-lg-7"> <div className="  fw-600 pe-lg-4 pe-1">%</div>  10</div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col p-2" >
                        <div className="box-1 box-1-color px-lg-4 px-3 py-lg-4 py-3" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2  text-small fw-600">BTC Value</small>
                            <div className=" fw-600 d-flex pt-2 fs-lg-7"> <div className=" fw-600 pe-lg-4 pe-1">$</div>  10,000,0000,000</div>
                            <div className=" fw-600 d-flex pt-1 fs-lg-7"> <div className=" fw-600 pe-lg-4 pe-1">%</div>  10</div>
                        </div>
                    </div>
                </div>
                {/* <div className="row mx-0">
                    <div className="col p-2" >
                        <div className="box-1 box-1-color py-4 px-lg-4 px-4" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2 text-faded text-small fw-600">Partnerships Value</small>
                            <div className=" text-pink fw-600 d-flex pt-2"> <div className=" text-pink fw-600 pe-4">$</div>  10,00000,0000</div>
                            <div className=" text-pink fw-600 d-flex pt-1"> <div className=" text-pink fw-600 pe-4">%</div>  30</div>
                        </div>
                    </div>
                    <div className="col p-2" >
                        <div className="box-1 box-1-color py-4 px-lg-4 px-4" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2 text-faded text-small fw-600">USD Value</small>
                            <div className=" text-purple fw-600 d-flex pt-2"> <div className=" text-purple fw-600 pe-4">$</div>  10,000,000</div>
                            <div className=" text-purple fw-600 d-flex pt-1"> <div className=" text-purple fw-600 pe-4">%</div>  50</div>
                        </div>
                    </div>
                    <div className="col p-2" >
                        <div className="box-1 box-1-color py-4 px-lg-4 px-4" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2 text-faded text-small fw-600">ETH Value</small>
                            <div className=" text-pink fw-600  d-flex pt-2"> <div className=" text-pink fw-600 pe-4">$</div>  10,0000,0000</div>
                            <div className=" text-pink fw-600 d-flex pt-1"> <div className=" text-pink fw-600 pe-4">%</div>  10</div>
                        </div>
                    </div>
                    <div className="col p-2" >
                        <div className="box-1 box-1-color py-4 px-lg-4 px-4" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                            <small className=" pb-2 text-faded text-small fw-600">BTC Value</small>
                            <div className=" text-purple fw-600 d-flex pt-2"> <div className=" text-purple fw-600 pe-4">$</div>  10,000,0000,000</div>
                            <div className=" text-purple fw-600 d-flex pt-1"> <div className=" text-purple fw-600 pe-4">%</div>  10</div>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    )
}
